import { Plugins } from '@leverege/plugin';
export default class AmplitudeTracker {
  constructor(options) {
    const {
      apiKey,
      ...opts
    } = options || {};
    this.apiKey = apiKey;
    this.options = opts;
  }
  async init() {
    if (this.apiKey) {
      const amplitude = await import('@amplitude/analytics-browser');
      this.amplitude = amplitude;
      amplitude.init(this.apiKey, {
        defaultTracking: true,
        ...this.options
      });
      Plugins.on('AmplitudePlugin', this.addPlugin);
    }
  }
  pageView(location) {}
  addPlugin = async ({
    plugin: plg
  }) => {
    let plugin = plg.init(this.options);
    if (plugin.then) {
      plugin = await plugin;
    }
    this.amplitude.add(plugin);
  };
  event(action, data) {
    if (this.amplitude) {
      this.amplitude.track(action, data);
    }
  }
  set(property, value) {
    switch (property) {
      case 'userId':
        this.amplitude.setUserId(value);
        break;
      default:
    }
  }
}